import { calculateDistancePointPoly, coordToArr } from "@nova/calculate-geospatial"
import { DistanceUnit, HotspotStatus, HotspotWithLabel } from "@nova/constants"
import { createHotspotsKML } from "@nova/data-create-hotspots-kml"
import { createPolygonKML } from "@nova/data-create-polygon-kml"
import { createSVGFromKML } from "@nova/data-create-svg-from-kml"
import { Polygon } from "@nova/protobuf"
import { useMemo } from "react"

type HotspotInPerimeterProps = {
    hotspot: HotspotWithLabel
    polygons: Polygon[]
    distanceUnit?: DistanceUnit
}
export const HotspotInPerimeterBox = ({ hotspot, polygons }: HotspotInPerimeterProps) => {
    const { svg } = useMemo(() => {
        if (!polygons.length) {
            return {
                svg: "",
                distance: 0,
            }
        }
        // cutting off the knot at the end of the poly
        const distances = polygons.map((poly) =>
            calculateDistancePointPoly(hotspot, poly.coordinates.slice(0, -1))
        )
        const { nearest, distance } = distances.reduce((previous, current) => {
            return current.distance < previous.distance ? current : previous
        }, distances[0])
        const svg = createSVGFromKML(
            [
                `<Placemark>
                      <DashedLineString>
                        <coordinates> ${hotspot.longitude},${hotspot.latitude},0
                ${nearest.longitude},${nearest.latitude},0
                        </coordinates>
                      </DashedLineString>
                    </Placemark>`,
                createPolygonKML(
                    "",
                    polygons.map((polygon) => ({
                        coords: polygon.coordinates.map((e) => coordToArr(e) as [number, number]),
                    }))
                ),
                createHotspotsKML(
                    [{ ...hotspot, status: HotspotStatus.Active, color: [255, 0, 0, 255] }],
                    { relativeSizeEnabled: false }
                )!,
            ],
            24,
            24,
            0,
            1,
            "#E51A1A66",
            { height: 0, width: 0 },
            { size: 1.5 }
        )
        return {
            svg,
            distance,
        }
    }, [hotspot, polygons])
    return (
        <img
            src={`data:image/svg+xml;base64,${btoa(svg)}`}
            alt="svg"
            className="pointer-events-none"
        />
    )
}
